import { isEmpty } from '@src/utils/functions/utils'
import { values } from 'video.js/dist/types/utils/obj'

export const getAdditionalAttributesValuefromHypenatedString = (additionalAttributes: string[] | undefined) => {
  if (isEmpty(additionalAttributes)) return {}
  const additionalAttributesObject: Record<string, string> = {}
  additionalAttributes?.forEach(attr => {
    const [key, value] = attr.split('-')
    if (key && value) {
      additionalAttributesObject[key] = value
    }
  })
  return additionalAttributesObject
}

export const getCommaSeparatedAdditionalAttributesValue = (
  additionalAttributes: Record<string, string> | undefined,
) => {
  if (isEmpty(additionalAttributes)) return []
  // We are spliiting the string (age-kid) which we are getting from contentful and creating a object ({age: kid}) out of it but master
  // contentful can have without hypenated Additional Attributes value (kid) which will give object ({kid: undefined}) to handle this issue
  // we are reading value first if value does not exist then pasing the key.
  const values = additionalAttributes?.map(value => value)

  return values.filter(Boolean).join(',')
}

export const getCommaSeparatedAdditionalAttributesValueString = (
  additionalAttributes: Record<string, string> | undefined,
): string | undefined => {
  if (isEmpty(additionalAttributes)) return undefined
  // We are spliiting the string (age-kid) which we are getting from contentful and creating a object ({age: kid}) out of it but master
  // contentful can have without hypenated Additional Attributes value (kid) which will give object ({kid: undefined}) to handle this issue
  // we are reading value first if value does not exist then pasing the key.
  const values = additionalAttributes.map(value => value)
  return values.filter(Boolean).join(',')
}
